require('./hireCardRevolvingStep5.scss');

// @ vendors
const PropTypes = require('prop-types');
const React = require('react');
const ReactDOM = require('react-dom');

// @ helpers
const { FormattedText, formatText, getLanguage } = require('core/i18n').i18n;
const { formatAmountObject, formatAmount } = require('utilities/currencyHelper');
const PersonalDataHelper = require('utilities/personalDataHelper');
const { recordLink } = require('utilities/tagging');
const { contactCenterClassName } = require('utilities/conditionals/conditionalClassname');

//@commons
const { OKConsents } = require('gdpr-consents/components/OKConsents/OKConsents.js');
const { OKCheckbox } = require('commonsComponents/OKCheckbox');
const PreContractualDocumentViewer = require('components/commons/preContractualDocumentViewer/preContractualDocumentViewer');

// @components
const { GDPRSignaturePattern } = require('components/gdprSignaturePattern/gdprSignaturePattern');
const { OneLineSymbolAmount } = require('commonsComponents/oneLineSymbolAmount');
const WebappRender = require('components/conditionalRender/webappRender');
const ContactCenterRender = require('components/conditionalRender/contactCenterRender');
const {
    CONFIRMATION_SCRIPT_AGREEMENT,
    CONFIRMATION_SCRIPT_GREETING,
    ConfirmationScript,
} = require('components/contactCenter/confirmScript/confirmationScript');

// @constants
const {
    CARD_PAYMENT_METHOD_FIXED,
    CARD_PAYMENT_METHOD_UNIQUE,
    CARD_PAYMENT_METHOD_VARIABLE,
    CARD_REVOLVING_PRODUCT_SUBTYPE,
    CARD_REVOLVING_PRODUCT_TYPE,
    EURO_SYMBOL,
    EURO_TEXT,
    FIFTH_STEP,
    HYPHEN,
    PROC_CARD_REVOLVING,
} = require('constants/index');
const getCardsPreContractPdfData = require('constants/cardsPreContractualsPdf');
const { REVOLVING_GDPR_ID } = require('constants/gdprPlacementIds');
const {
    ADD_NEW_SHIPPING_ADDRESS,
    MULTIPLE_OPERATIONS,
    REVOLVING_HIRE,
    messages: {REVOLVING_HIRE_AND_GDPR}
} = require('constants/operationTypes');

class HireCardRevolvingStep5 extends React.Component {

    constructor(props) {
        super(props);

        this.setNode = this.setNode.bind(this);
    }

    componentDidMount() {
        const {
            immHireCardRevolving,
            sendPrecontractualDocumentMail,
            setTermsAndCondsText,
        } = this.props;
        const precontractualMailProductInfo = {
            producto: CARD_REVOLVING_PRODUCT_TYPE,
            standard: immHireCardRevolving.get('referenceStandard'),
            subproducto: CARD_REVOLVING_PRODUCT_SUBTYPE,
        };

        sendPrecontractualDocumentMail(precontractualMailProductInfo);

        if (!__CONTACT_CENTER__) {
            //This action is also called in the first step of the current hiring, if you update one remeber that maybe you should update the other one
            setTermsAndCondsText('hireCardRevolving-hireCardRevolving_confirmationStepAgreementText');
        }
        this.handleCMSLinks();
    }

    componentWillUnmount() {
        this.handleCMSLinks(true);
    }

    setNode(ref) {
        this.nodeReference = ref;
    }

    handleCMSLinks(removeOnly = false) {
        const element = ReactDOM.findDOMNode(this.nodeReference);
        if (!!element) {
            const anchors = element.getElementsByTagName('a');
            Array.from(anchors).forEach(anchorElement => {
                anchorElement.removeEventListener('click', () => {});
                if (!removeOnly) {
                    anchorElement.addEventListener('click', () => {
                        recordLink(PROC_CARD_REVOLVING, anchorElement.text);
                    });
                }
            });
        }
    }

    buildSummary() {
        const {
            immHireCardNameSelector,
            immHireCreditLimit,
            immHirePaymentMethod,
            immShippingAddress,
        } = this.props;

        const limitObj = {
            amount: immHireCreditLimit.get('creditLimit'),
            currency: EURO_TEXT
        };

        const paymentMethod = {
            [CARD_PAYMENT_METHOD_UNIQUE]: `${formatText('hireCardRevolving-summaryMethodOfPaymentFullPay')}`,
            [CARD_PAYMENT_METHOD_FIXED]: `${formatText('hireCardRevolving-summaryMethodOfPaymentDeferredFixedFee')}`,
            [CARD_PAYMENT_METHOD_VARIABLE]: `${formatText('hireCardRevolving-summaryMethodOfPaymentDeferredVariableFee')}`
        };

        const paymentMethodType = immHirePaymentMethod.get('type');
        const paymentMethodText = paymentMethod[paymentMethodType];
        const paymentMethodSymbol = paymentMethodType === CARD_PAYMENT_METHOD_FIXED ? EURO_SYMBOL: '%';
        const paymentMethodValue = paymentMethodType === CARD_PAYMENT_METHOD_UNIQUE
            ? paymentMethodText
            : `${paymentMethodText} ${formatAmount(immHirePaymentMethod.get('value'), getLanguage(), 0)} ${paymentMethodSymbol}`;

        const addressValue = immShippingAddress.get('isFetching') ? HYPHEN : PersonalDataHelper.getHireFormattedAddress(immShippingAddress);
        const hireCardRevolvingLabelClassName = contactCenterClassName('print-label', 'hire-card-revolving-step-five__summary-label');

        return (
            <div className="hire-card-revolving-step-five__summary row">
                <div className="col-xs-6">
                    <div className={hireCardRevolvingLabelClassName}>
                        <FormattedText value="hireCardRevolving-summarySelectedName" />
                    </div>
                    <div className="hire-card-revolving-step-five__summary-value">
                        {immHireCardNameSelector.getIn(['names', immHireCardNameSelector.get('selectedIndex')])}
                    </div>
                </div>
                <div className="col-xs-6">
                    <div className={hireCardRevolvingLabelClassName}>
                        <FormattedText value="hireCardRevolving-summarySelectedLimit" />
                    </div>
                    <div className="hire-card-revolving-step-five__summary-value--highlight">
                        <OneLineSymbolAmount
                            amountObject={limitObj}
                            language={getLanguage()}
                            amountObjectFormatted={formatAmountObject(limitObj, true)}
                            trimDecimals={true}
                        />
                    </div>
                </div>
                <div className="col-xs-6">
                    <div className={hireCardRevolvingLabelClassName}>
                        <FormattedText value="hireCardRevolving-summaryPaymentMethod" />
                    </div>
                    <div className="hire-card-revolving-step-five__summary-value">
                        {paymentMethodValue}
                    </div>
                </div>
                <div className="col-xs-6">
                    <div className={hireCardRevolvingLabelClassName}>
                        <FormattedText value="hireCardRevolving-summaryShippingAddress" />
                    </div>
                    <div className="hire-card-revolving-step-five__summary-value">
                        {addressValue}
                    </div>
                </div>
            </div>
        );
    }

    render() {
        const { immHireCardRevolving, operativeName, immPdfData } = this.props;
        const immStep = immHireCardRevolving.getIn(['steps', FIFTH_STEP]);
        const ineUrl = formatText(`hireCardRevolving-step4IneUrlPack${immHireCardRevolving.get('pack')}`);
        const agreementLabel = (
            <FormattedText
                injectedStrings={[ineUrl]}
                value="hireCardRevolving-hireCardRevolving_confirmationStepAgreementText"
            />
        );
        const agreementChecked = immStep.get('agreementChecked');
        const agreementErrorVisible = immStep.get('agreementIsDirty') && !immStep.get('agreementChecked');
        const agreementErrorMsg = formatText('hireCardRevolving-step4CheckboxErrorMsg');
        const pdfError = immPdfData.get('errorContent');
        const summaryContent = this.buildSummary();
        const operationParams = [{
            serviceCode: REVOLVING_HIRE
        },{
            serviceCode: ADD_NEW_SHIPPING_ADDRESS
        }];

        const preContractDocumentInfo = getCardsPreContractPdfData()['revolving_card'];
        let agreementCheckboxContent, GDPRSignaturePatternContent;

        const hireCardRevolvingTitleClassName = contactCenterClassName('print-title', 'hire-card-revolving-step-five__title');
        const hireCardRevolvingSubTitleClassName = contactCenterClassName('print-paragraph', 'hire-card-revolving-step-five__subtitle');
        const printTitleValue = 'revolvingCard-step5TitlePrint';
        const operative = (__CONTACT_CENTER__ && operativeName) ? formatText(operativeName) : undefined;

        if(!pdfError) {
            agreementCheckboxContent = (
                <div className="hire-card-revolving-step-five__checkbox-container" ref={this.setNode}>
                    <OKCheckbox
                        idName="hireCardRevolvingAgreementCheckbox"
                        errorState={agreementErrorVisible}
                        errorMessage={agreementErrorMsg}
                        label={agreementLabel}
                        onChange={this.props.handleAgreementCheckboxChange}
                        value={agreementChecked}
                    />
                </div>
            )
        }

        if(agreementChecked) {
            GDPRSignaturePatternContent = (
                <GDPRSignaturePattern
                    operationType={MULTIPLE_OPERATIONS}
                    operationParams={operationParams}
                    multiOTPMessageCode={REVOLVING_HIRE_AND_GDPR}
                    printTitleValue={printTitleValue}
                />
            )
        }

        return (
            <article className="hire-card-revolving-step-five">
                <FormattedText
                    className={hireCardRevolvingTitleClassName}
                    value="hireCardRevolving-step4Title"
                />
                <ContactCenterRender>
                    <ConfirmationScript
                        confirmationType={CONFIRMATION_SCRIPT_GREETING}
                        operative={operative}
                    />
                </ContactCenterRender>
                <FormattedText
                    className={hireCardRevolvingSubTitleClassName}
                    value="hireCardRevolving-step4Subtitle"
                />
                {summaryContent}
                <OKConsents placementId={REVOLVING_GDPR_ID} />
                <WebappRender>
                    <div className="hire-card-revolving-step-five__pdf-viewer-container">
                        <PreContractualDocumentViewer
                            preContractDocumentInfo={preContractDocumentInfo}
                            titleKey="preContractDocument_pdfTitleINE"
                        />
                    </div>
                    {agreementCheckboxContent}
                </WebappRender>
                <ContactCenterRender>
                    <ConfirmationScript confirmationType={CONFIRMATION_SCRIPT_AGREEMENT} />
                </ContactCenterRender>
                {GDPRSignaturePatternContent}
            </article>
        );
    }
}

HireCardRevolvingStep5.propTypes = {
    handleAgreementCheckboxChange: PropTypes.func.isRequired,
    immHireCardNameSelector: PropTypes.object.isRequired,
    immHireCardRevolving: PropTypes.object.isRequired,
    immHireCreditLimit: PropTypes.object.isRequired,
    immHirePaymentMethod: PropTypes.object.isRequired,
    immPdfData: PropTypes.object.isRequired,
    immShippingAddress: PropTypes.object.isRequired,
    operativeName: PropTypes.string,
    sendPrecontractualDocumentMail: PropTypes.func.isRequired,
    setTermsAndCondsText: PropTypes.func.isRequired,
};

module.exports = HireCardRevolvingStep5;
